import { all, call, takeLatest } from 'typed-redux-saga';

import { WakeLockManager } from '../../../../shared/helpers/wake-lock/wake-lock-manager';
import { cancelCallAction, connectedToConferenceDoneAction } from '../conference/slice';

export function* wakeLockSaga() {
    if (WakeLockManager.isWakeLockSupported()) {
        const wakeLockManager = new WakeLockManager();
        yield all([
            takeLatest(connectedToConferenceDoneAction, function* () {
                yield call([wakeLockManager, wakeLockManager.requestWakeLock]);
            }),
            takeLatest(cancelCallAction, function* () {
                yield call([wakeLockManager, wakeLockManager.releaseWakeLock]);
            }),
        ]);
    }
}
